import { cn } from 'lib/helpers/utility';

import Avatar from 'components/shared/Avatar/Avatar';
import Icon from 'components/shared/Icon/Icon';

const SupportContactCard = ({ title, contact, className = '' }) => {
  const name = contact
    ? `${contact.firstName ?? ''} ${contact.lastName ?? ''}`.trim()
    : 'Not assigned yet';

  return (
    <div className={cn('rounded-lg border border-solid border-neutral-200 p-5', className)}>
      <h3 className="text-sm font-500 text-neutral-900">{title}</h3>
      <div className="my-3 border-t border-b-0 border-solid border-neutral-200" />
      <div className="flex items-center gap-2">
        {contact ? (
          <Avatar
            firstName={contact.firstName}
            lastName={contact.lastName}
            id={contact.id}
            image={contact.profile_picture}
            size="small"
            isSquare={false}
          />
        ) : null}
        <span className="text-sm text-neutral-900">{name}</span>
      </div>
      {contact?.email && (
        <div className="mt-2.5 flex items-center gap-2">
          <Icon icon="mail-mono" color="neutral" />
          <span className="text-sm text-neutral-600">{contact.email}</span>
        </div>
      )}
      {contact?.phone && (
        <div className="mt-2 flex items-center gap-2">
          <Icon icon="call-calling-mono" color="neutral" />
          <span className="text-sm text-neutral-600">{contact.phone}</span>
        </div>
      )}
    </div>
  );
};

export default SupportContactCard;
